import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
});

// function TextMaskCustom(props) {
//   const { inputRef, ...other } = props;

//   return (
//     <MaskedInput
//       {...other}
//       ref={ref => {
//         inputRef(ref ? ref.inputElement : null);
//       }}
//       mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
//       placeholderChar={'\u2000'}
//       showMask
//     />
//   );
// }

// TextMaskCustom.propTypes = {
//   inputRef: PropTypes.func.isRequired,
// };

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={"."}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class AmountFormatCustom extends React.Component {
  state = {
    // textmask: '(1  )    -    ',
    numberformat: '0.00',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
    this.props.onBlur(event);
  };

  render() {
    const { classes } = this.props;
    const { /*textmask,*/ numberformat } = this.state;
    return (
        <TextField
          style = {{width:this.props.setStyle && this.props.setStyle}}
          readOnly={this.props.readOnly}
          value={this.props.defaultValue || numberformat}
          variant="standard"
          className={classes.formControl}
          onChange={this.handleChange('numberformat')}
          onBlur={this.props.onBlur}
          id={this.props.id}
          name={this.props.name}
          InputProps={{
            inputComponent: NumberFormatCustom,
            readOnly: Boolean(this.props.readOnly),
            autocomplete: 'off',
            form: {
              autocomplete: 'off',
            },
          }}
        />
    //   </div>
    );
  }
}

AmountFormatCustom.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AmountFormatCustom);



// WEBPACK FOOTER //
// ./src/components/common/AmountFormat.js